module.exports = __webpack_public_path__ + "c358bd4c36e4abd3d6f56586da2c8436.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/tablet.png
// module id = 2131
// module chunks = 0